const PLACEHOLDER_ICON_URL =
  'https://cdn.shopify.com/s/files/1/0789/9761/8927/files/placeholder_image.png?v=1774509537';
const DATA_FALLBACK_APPLIED = 'fallbackApplied';
const DATA_IMAGE_LOADED = 'imageLoaded';

/**
 * @returns {{ backgroundColor: string; centerIcon: string; ratioWidth: string; maxWidth: string }}
 */
function getPlaceholderConfig() {
  const windowWithTheme = /** @type {Window & { Theme?: any }} */ (window);
  const themeObject = (typeof Theme !== 'undefined' && Theme) || windowWithTheme.Theme || {};
  const config = themeObject.imagePlaceholder || {};

  return {
    backgroundColor: config.backgroundColor || '#EFEFEF',
    centerIcon: config.centerIcon || PLACEHOLDER_ICON_URL,
    ratioWidth: config.ratioWidth || '25%',
    maxWidth: config.maxWidth || '240px',
  };
}

function applyRootCssVariables() {
  const { backgroundColor, centerIcon, ratioWidth, maxWidth } = getPlaceholderConfig();
  const root = document.documentElement.style;
  root.setProperty('--image-placeholder-bg', backgroundColor);
  root.setProperty('--image-placeholder-center-icon', centerIcon ? `url("${centerIcon}")` : 'none');
  root.setProperty('--image-placeholder-ratio-width', ratioWidth);
  root.setProperty('--image-placeholder-max-width', maxWidth);
}

/**
 * @returns {string}
 */
function buildTransparentFallbackDataUri() {
  const svg =
    "<svg xmlns='http://www.w3.org/2000/svg' width='1' height='1' viewBox='0 0 1 1'><rect width='1' height='1' fill='transparent'/></svg>";
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/**
 * @param {HTMLImageElement} image
 * @returns {boolean}
 */
function shouldSkipImage(image) {
  if (image.hasAttribute('data-no-placeholder')) return true;
  if (image.closest('[data-no-placeholder-scope]')) return true;
  return false;
}

/**
 * @param {HTMLImageElement} image
 */
function applyFallbackOnce(image) {
  if (image.dataset[DATA_FALLBACK_APPLIED] === 'true') return;
  if (shouldSkipImage(image)) return;

  image.dataset[DATA_FALLBACK_APPLIED] = 'true';
  delete image.dataset[DATA_IMAGE_LOADED];
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = buildTransparentFallbackDataUri();
}

/**
 * @param {Event} event
 */
function onImageError(event) {
  const image = event.target;
  if (!(image instanceof HTMLImageElement)) return;
  applyFallbackOnce(image);
}

/**
 * @param {Event} event
 */
function onImageLoad(event) {
  const image = event.target;
  if (!(image instanceof HTMLImageElement)) return;
  if (shouldSkipImage(image)) return;
  if (image.dataset[DATA_FALLBACK_APPLIED] === 'true') return;
  image.dataset[DATA_IMAGE_LOADED] = 'true';
}

function fixBrokenAlreadyCompleteImages() {
  document.querySelectorAll('img').forEach((node) => {
    if (!(node instanceof HTMLImageElement)) return;
    if (shouldSkipImage(node)) return;
    if (!node.complete) return;
    if (node.naturalWidth > 0) {
      node.dataset[DATA_IMAGE_LOADED] = 'true';
      return;
    }
    applyFallbackOnce(node);
  });
}

applyRootCssVariables();
document.addEventListener('load', onImageLoad, true);
document.addEventListener('error', onImageError, true);
fixBrokenAlreadyCompleteImages();

